import { MessagingApiClient } from "@/clients/messagingApiClient";
import {
  ConsultantThread,
  ConsultantMessage,
  ThreadStatus,
  ThreadWithMessages,
} from "@/types/messaging";

export class MessagingService {
  private client: MessagingApiClient;

  constructor() {
    this.client = new MessagingApiClient();
  }

  async listThreads(opts: {
    companyId?: string;
    status?: ThreadStatus;
  }): Promise<ConsultantThread[]> {
    const { threads } = await this.client.listThreads(opts);
    return threads;
  }

  async getThread(threadId: string): Promise<ThreadWithMessages> {
    return this.client.getThread(threadId);
  }

  async createThread(opts: {
    companyId: string;
    subject?: string;
  }): Promise<ConsultantThread> {
    const { thread } = await this.client.createThread(opts);
    return thread;
  }

  async sendMessage(opts: {
    threadId: string;
    body: string;
    isFromAiDraft?: boolean;
  }): Promise<ConsultantMessage> {
    const { message } = await this.client.sendMessage(opts);
    return message;
  }

  async updateThreadStatus(
    threadId: string,
    status: ThreadStatus,
  ): Promise<ConsultantThread> {
    const { thread } = await this.client.updateThreadStatus(threadId, status);
    return thread;
  }

  async generateAiReply(threadId: string): Promise<string> {
    return this.client.generateAiReply(threadId);
  }

  async suggestSubject(threadId: string): Promise<string> {
    return this.client.suggestSubject(threadId);
  }

  async updateSubject(threadId: string, subject: string): Promise<ConsultantThread> {
    return this.client.updateSubject(threadId, subject);
  }

  async getAttachmentDownloadUrl(attachmentId: string): Promise<string> {
    return this.client.getAttachmentDownloadUrl(attachmentId);
  }
}
